import React from "react";
import {Activity} from "../../types/Activity";
import {DateUtility} from "../common/DateUtility";
import {StringUtility} from "../common/StringUtility";
import {ActivityDirectionDisplay} from "./ActivityDirectionDisplay";
import _ from "lodash";

interface ActivitySubRowsProps {
    activities: Activity[];
    filterBrokerId?: any;
}

export let ActivitySubRows = function (props: ActivitySubRowsProps) {
    let activitySubRows: React.ReactNode[] = [];
    for (let i = 0; i < props.activities.length; i++) {
        let activity = props.activities[i];
        let activityBrokerAssignments = activity.activity_broker_assignments || [];
        // when the broker filter is active, show only the filtered broker's assignment lines and hide an activity that has none of them
        if (props.filterBrokerId != null) {
            activityBrokerAssignments = activityBrokerAssignments.filter(function (activityBrokerAssignmentToFilter) {
                return '' + activityBrokerAssignmentToFilter.broker_id === '' + props.filterBrokerId;
            });
            if (activityBrokerAssignments.length === 0) {
                continue;
            }
        }
        let startTimeDisplay: React.ReactNode[] = [];
        let materialDisplay: React.ReactNode[] = [];
        let countDisplay: React.ReactNode[] = [];
        let brokerNameDisplay: React.ReactNode[] = [];
        let activityBrokerAssignmentsSorted = _.sortBy(
            activityBrokerAssignments,
            function (activityBrokerAssignmentToSort) {
                return DateUtility.dbDateToJsDate(activityBrokerAssignmentToSort.start_time)?.getTime()
            }
        )
        for (let k = 0; k < activityBrokerAssignmentsSorted.length; k++) {
            let activityBrokerAssignment = activityBrokerAssignmentsSorted[k];
            let assignedMaterial = activityBrokerAssignment.assigned_activity_material;
            let roundRobinIcon = undefined;
            if (activityBrokerAssignment.is_round_robin) {
                roundRobinIcon = <img
                    src="/static/images/round-robin-light-gray-on-textcolor.svg"
                    className="activity-broker-assignment-row-round-robin-icon"
                />
            }
            // show activity broker assignment start time/material info if present
            startTimeDisplay.push(
                <div
                    key={`activity-broker-assignment-time-${k}`}
                    className="activity-sub-row-time-cell"
                >
                    <div className="activity-sub-row-cell-text">
                        {DateUtility.dbDateToDisplayTime(activityBrokerAssignment.start_time)}
                    </div>
                </div>
            );
            materialDisplay.push(
                <div
                    key={`activity-broker-assignment-material-${k}`}
                    className="activity-sub-row-material-cell"
                >
                    <div className="activity-sub-row-cell-text">
                        {
                            assignedMaterial
                                ? StringUtility.toInitialCaps('' + activityBrokerAssignment.assigned_material_amount + ' ' + assignedMaterial.measurement_unit + 's ' + assignedMaterial.name)
                                : ''
                        }
                    </div>
                </div>
            );
            countDisplay.push(
                <div
                    key={`activity-broker-assignment-count-${k}`}
                    className="activity-sub-row-truck-count-cell"
                >
                    <div className="activity-sub-row-truck-count-cell-content">
                        <div className="activity-broker-assignment-count-text">
                            {
                                activityBrokerAssignment.pit_haul
                                    ? '+'
                                    : (activityBrokerAssignment.truck_count != null ? String('' + activityBrokerAssignment.truck_count).padStart(2, '0') : '')
                            }
                        </div>
                        <div className="activity-broker-assignment-truck-count-icon-cell">
                            <img
                                src="/static/images/truck-textcolor.svg"
                                className="activity-broker-assignment-truck-count-icon"
                            />
                        </div>
                        {roundRobinIcon}
                    </div>
                </div>
            );
            brokerNameDisplay.push(
                <div
                    key={`activity-broker-assignment-broker-name-${k}`}
                    className="activity-sub-row-broker-cell"
                >
                    {activityBrokerAssignment.broker?.name}
                </div>
            )
        }

        // fall back to displaying activity-level start time and material info if it's not yet defined at the activity broker assignment level
        if (startTimeDisplay.length === 0) {
            startTimeDisplay.push(
                <div
                    key="activity-broker-assignment-time-0"
                    className="activity-sub-row-time-cell"
                >
                    <div className="activity-sub-row-cell-text">
                        {DateUtility.dbDateToDisplayTime(activity.activity_start_time)}
                    </div>
                </div>
            );
        }
        if (materialDisplay.length === 0) {
            materialDisplay.push(
                <div
                    key="activity-broker-assignment-material-0"
                    className="activity-sub-row-material-cell"
                >
                    <div className="activity-sub-row-cell-text">
                        {
                            activity.requested_activity_material
                                ? StringUtility.toInitialCaps('' + activity.requested_material_amount + ' ' + activity.requested_activity_material.measurement_unit + 's ' + activity.requested_activity_material.name)
                                : ''
                        }
                    </div>
                </div>
            );
        }

        activitySubRows.push(
            <div key={`activity-sub-row-${i}`} className="activity-sub-row">
                <div className="activity-sub-row-content">
                    <div className="activity-sub-row-cell activity-sub-row-direction">
                        <ActivityDirectionDisplay directionName={activity.activity_direction.name} abbreviated={true}/>
                    </div>
                    <div className="activity-sub-row-cell activity-sub-row-po">
                        <div className="activity-sub-row-cell-text" title={'' + activity.purchase_order_number}>
                            {activity.purchase_order_number}
                        </div>
                    </div>
                    <div className="activity-sub-row-cell activity-sub-row-time">
                        <div className="activity-sub-row-time-content">
                            {startTimeDisplay}
                        </div>
                    </div>
                    <div className="activity-sub-row-cell activity-sub-row-material">
                        <div className="activity-sub-row-material-content">
                            {materialDisplay}
                        </div>
                    </div>
                    <div className="activity-sub-row-cell activity-sub-row-truck-count">
                        <div className="activity-sub-row-truck-count-content">
                            {countDisplay}
                        </div>
                    </div>
                    <div className="activity-sub-row-cell activity-sub-row-broker">
                        <div className="activity-sub-row-broker-content">
                            {brokerNameDisplay}
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    return <>{activitySubRows}</>;
};
